module.exports = __webpack_public_path__ + "img/react.af5ac421.svg";